import { WbfPolicies } from '@workers-benefit-fund/shared-data'
import { lazy } from 'react'
import { useParams } from 'react-router-dom'

import { BasicBlock } from 'src/common/components'

import withErrorBoundaryAndPolicyCheck from '../../../../v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import styles from './person-notes-block.module.scss'

import SuspenseFallback from '@v2/commons/components/SuspenseFallback/SuspenseFallback.component'
import { selectCurrentOrganization } from '@v2/domains/user/selectors/user.selectors'
import { useAppSelector } from '@v2/store/hooks'

const PersonNotesWidget = lazy(
  () => import('@v2/domains/personNotes/views/personNotesWidget.view'),
)

const PersonNotesBlock = ({
  setIsLeavingTheRecordWithoutNote,
}: {
  setIsLeavingTheRecordWithoutNote: React.Dispatch<
    React.SetStateAction<boolean>
  >
}) => {
  const { personId } = useParams<{ personId: string }>()
  const currentOrganization = useAppSelector(selectCurrentOrganization)
  const identity = `${currentOrganization.id}:${personId ?? ''}`

  return (
    <>
      <BasicBlock
        className={styles.wrapper}
        titleClassName={styles.title}
        headerClassName={styles.header}
      >
        {personId && (
          <SuspenseFallback rows={6}>
            <PersonNotesWidget
              key={identity}
              personId={personId}
              setIsLeavingTheRecordWithoutNote={
                setIsLeavingTheRecordWithoutNote
              }
            />
          </SuspenseFallback>
        )}
      </BasicBlock>
    </>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  PersonNotesBlock,
  WbfPolicies.is_get_person_all_notes_enabled,
)
